import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';

const ViewRequests = () => {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState('');
  const [customMessage, setCustomMessage] = useState('');

  useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      const res = await fetch('https://reviewhub-lc.onrender.com/api/request');
      const data = await res.json();
      setRequests(data);
    } catch (err) {
      console.error('Error fetching requests:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDialog = (email) => {
    setSelectedEmail(email);
    setCustomMessage('');
    setDialogOpen(true);
  };

  const handleSendMail = async () => {
    try {
      const response = await fetch('https://reviewhub-lc.onrender.com/api/request/send-mail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          to: selectedEmail,
          subject: 'Response to your request',
          message: customMessage,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        alert('Email sent successfully');
        setDialogOpen(false);
      } else {
        alert('Failed to send email: ' + result.message);
      }
    } catch (error) {
      alert('Error sending email');
      console.error(error);
    }
  };

  return (
    <Box p={4}>
      <Typography variant="h5" gutterBottom>
        Submitted Requests
      </Typography>

      {loading ? (
        <CircularProgress />
      ) : requests.length === 0 ? (
        <Typography>No requests found.</Typography>
      ) : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell><strong>Reseller ID</strong></TableCell>
                <TableCell><strong>Email</strong></TableCell>
                <TableCell><strong>Request Message</strong></TableCell>
                <TableCell><strong>Date</strong></TableCell>
                <TableCell><strong>Action</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {requests.map((req) => (
                <TableRow key={req._id}>
                  <TableCell>{req.resellerId}</TableCell>
                  <TableCell>{req.email}</TableCell>
                  <TableCell>{req.request}</TableCell>
                  <TableCell>{new Date(req.createdAt).toLocaleString()}</TableCell>
                  <TableCell>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleOpenDialog(req.email)}
                    >
                      Send Mail
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Popup Dialog */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Send Email to {selectedEmail}</DialogTitle>
        <DialogContent>
          <TextField
            multiline
            fullWidth
            rows={5}
            label="Message"
            value={customMessage}
            onChange={(e) => setCustomMessage(e.target.value)}
            variant="outlined"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)} color="secondary">Cancel</Button>
          <Button onClick={handleSendMail} color="primary" variant="contained">Send</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ViewRequests;
